<div>
  <ul>
    <li *ngIf="user?.moderator" class="">
      <a routerLink="/clients">{{ "posts.actions.clients.button" | translate }}</a>
    </li>
    <li *ngIf="user?.moderator" class="">
      <a (click)="exportToExcel()">Transactions</a>
    </li>
    <!--    <li class="">-->
    <!--        <a href="/contact">{{ "posts.actions.contact.button" | translate }}</a>-->
    <!--    </li>-->
    <!--    <li class="">-->
    <!--        <a target="_blank" [href]="cgvUrl">{{ "posts.actions.cgu.button" | translate }}</a>-->
    <!--    </li>-->
  </ul>
</div>
<div>
  <ul>
    <li class>
      <button mat-button [class]="getAddPostClassname(user)" (click)="tryOpenCreation()">
        <mat-icon aria-hidden="false" aria-label="create post icon" svgIcon="file-plus" class="create_icon"></mat-icon>
        <span class="create_label">{{ "posts.actions.create.button" | translate }}</span>
        <label *ngIf="user?.moderator" class="actions__create-mod__label">admin</label>
      </button>
    </li>
  </ul>
</div>
<!--    <li class="">-->
<!--        <a href="/posts">{{ "posts.actions.posts.button" | translate }}</a>-->
<!--    </li>-->

